import React, { useContext } from 'react';
import { bool, oneOf, string } from 'prop-types';
import className from 'classnames';
import { ProductPodContext } from '../../ProductPodContext';
import { getCustomUrlWithAnalytics } from '../../utils';
import './ProductHeader.style.scss';

export const ProductHeader = (props) => {
  const {
    brand,
    collection,
    large,
    target,
    disableShopThisCollection
  } = props;

  const {
    channel,
    brandMaxLine,
    hosts,
    onHeaderClick,
    pageType,
    podType,
    product,
    target: contextTarget,
    titleMaxLine,
    hover
  } = useContext(ProductPodContext);

  const {
    details,
    identifiers,
    info
  } = product || {};

  const {
    collection: collectionObj
  } = details || {};

  const {
    name: collectionName,
    url: collectionUrl
  } = collectionObj || {};

  const {
    canonicalUrl,
    brandName,
    productType = '',
    productLabel
  } = identifiers || {};

  if (!productLabel) return null;

  const isMobile = channel === 'mobile';
  const showShopThisCollectionLink = !disableShopThisCollection && collectionName
    && collectionUrl && collection === 'below' && podType !== 'grouped';

  const customExperience = info?.globalCustomConfigurator?.customExperience;
  const productURL = getCustomUrlWithAnalytics({
    customExperience,
    productType,
    blindsHost: hosts?.customBlinds,
    canonicalUrl,
    info
  });
  const headerTarget = isMobile ? '' : target || contextTarget;

  const titleClasses = className('product-pod__title', {
    'product-pod__title__product': brand === 'inline',
    'product-pod__title--large': large,
    'product-pod__title__spacer': isMobile
  });
  const labelClasses = className('product-pod__title__product', {
    'product-pod__title__product--twoline': pageType === 'dpd' || titleMaxLine === 2,
    'product-pod__title__product--mobiledpd': pageType === 'dpd' && isMobile
  });
  const brandClasses = className('product-pod__title__brand', {
    'product-pod__title__brand--oneline': pageType === 'dpd' || brandMaxLine === 1,
    'product-pod__title__brand--mobiledpd': pageType === 'dpd' && isMobile
  });
  const shopThisCollectionClasses = className('product-pod__title__collection', {
    'product-pod__title__collection--block': brand === 'inline'
      && (podType === 'default' || podType === 'list') && !hover
  });

  return (
    <>
      <div className={titleClasses}>
        <a
          href={productURL}
          onClick={onHeaderClick}
          target={headerTarget}
          className="header product-pod--ie-fix"
        >
          <div className="product-pod__title-control product-pod--ie-fix">
            <h2 className={titleClasses}>
              {brandName && brand === 'inline'
              && (
                <span className="product-pod__title__brand--bold">
                  {brandName}
                </span>
              )}
              <span className={labelClasses}>
                {productLabel}
              </span>
            </h2>
          </div>
        </a>
        {brandName && brand === 'below'
        && (
          <p className={brandClasses}>by
            <span className="product-pod__title__brand--bold"> {brandName}</span>
          </p>
        )}
      </div>
      {showShopThisCollectionLink && (
        <a className={shopThisCollectionClasses} href={collectionUrl} target={target || contextTarget}>
          Shop this Collection
        </a>
      )}
    </>
  );
};

ProductHeader.propTypes = {
  brand: oneOf(['below', 'hidden', 'inline']),
  collection: oneOf(['below', 'hidden']),
  disableShopThisCollection: bool,
  /** Larger text for title */
  large: bool,
  /** Target can be overridden but takes the context as default */
  target: string
};

ProductHeader.defaultProps = {
  brand: 'below',
  collection: 'below',
  disableShopThisCollection: false,
  large: false,
  target: null
};

ProductHeader.displayName = 'ProductHeader';

export default ProductHeader;
